import { useMutation } from '@tanstack/react-query';
import { getAuthModule } from '../install';
export function useApplyEmailVerification() {
    return useMutation({
        mutationFn: (input) => getAuthModule().actions.applyEmailVerification(input),
    });
}
